import { createDataSyncDecoder, type DataSyncDecoderHandlers } from '@gitbook/hive-core';
import { Logger } from '@gitbook/util-debug';
import type { WebSocket } from '@gitbook/util-websocket';

const logger = Logger('hive:client:decoder');

export function createV1Listener(handlers: DataSyncDecoderHandlers, ws: WebSocket) {
    const decoder = createDataSyncDecoder(handlers);
    ws.listen('message', (message) => {
        if (typeof message === 'string') {
            return;
        }
        Promise.resolve(decoder(message)).catch((error) => {
            logger.error('Failed to decode message', error);
        });
    });
}
